<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="clearFormData(null)"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody v-for="(item , index) in dataTable" :key="item.id">
            <tr>
              <td width=" 5%" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td width=" 15%">{{item.branch ? item.branch.branch_name_en : ''}}</td>
              <td >{{item.address_th}}</td>
              <td width=" 20%">{{item.opening_hours_detail_th}}</td>
              <td width=" 15%">{{item.updated_at | moment('DD-MM-YYYY')}}</td>
              <td  width=" 5%">
                <a @click="showLocationData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "LocationTable",
  components: {Paginate, IconPencil, InputSearch, CircleButton },
  data() {
    return {
      title: "Location",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Address" },
        { id: 4, text: "Opening hours detail" },
        { id: 5, text: "Update date" },
        { id: 6, text: "Edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getLocationTable(1);
  },
  methods:{
    getLocationTable(page){
      this.$store.dispatch("Location/getLocation",page).then(res=>{
        if(res.response_code == 200){
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        }
      }).catch(()=>{
        alert('cannot to response location data');
      });
    },

    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("Location/getLocation", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    goToLocationEdit(){
      this.$router.push("/location/edit");
    },
    clearFormData(){
      this.$store.dispatch("Location/clearFormData").then(()=>{
        this.goToLocationEdit();
      });
    },
    showLocationData(id){
      this.$store.dispatch("Location/showLocation",id).then(res=>{
        if(res.response_code == 200){
          this.$store.dispatch("Location/setFormLocation",res.result).then(()=>{
            this.goToLocationEdit();
          });
        }
      }).catch(()=>{
        alert('cannot to response location data');
      });
    }
  },
};
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
